import http from "../plugins/axios";
import { AxiosError } from "axios";

export interface ArticleModel {
  title: string;
  intro: string;
  author: string;
  body: string;
  pub_time: Date;
  id: number;
}

export interface ContestModel {
  title: string;
  id: number;
  isVisible: boolean;
  tracks: number[];
  articles: ArticleModel[];
}
export interface ContestResult {
  size: number;
  data: ContestModel[];
}

export function getContests(token: string): Promise<ContestResult> {
  return new Promise((resolve, reject) => {
    http
      .get("/api/competition", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        return resolve(response.data as ContestResult);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}
export function getContest(token: string, id: number): Promise<ContestModel> {
  return new Promise((resolve, reject) => {
    http
      .get(`/api/competition/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        return resolve(response.data as ContestModel);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}
